import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://irjsuksqjlccjonymtdk.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlyanN1a3NxamxjY2pvbnltdGRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI0NjYzNjUsImV4cCI6MjA5ODA0MjM2NX0.yjaUB5wUORSRf6UUIMjboJB28uKxeWjt0pE6ImgIKq8'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})